<template>
<div class="section section-2 py-md-5">
  <div class="container">
    <h2 class="text-center section__title-principal mb-3">Estadísticas por comuna</h2>
    <div class="row">
      <div class="col-12 col-md-6">
          <div class="section__title">
          <h2>CORONAVIRUS <span>en {{ getZonaById(datos[0].id) || `comunas de ${getZonaById(datos[1].id)}` }}</span></h2>
          </div>
            <div class="section__box-select">
              <multiselect
              v-model="selectedComunas[0]"
              track-by="value"
              label="text"
              placeholder="Seleccione una comuna"
              :options="comunas"
              @input="changeComunasIzq"
              selectLabel="Presione enter para seleccionar"
              deselectLabel="Presiones enter para remover"
              selectedLabel="Seleccionado"
              >
              <template slot="noResult">Sin resultados</template>
              <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.text }}</strong></template>
            </multiselect>
          </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="section__title pt-3 pt-md-0">
          <h2>CORONAVIRUS <span>en {{ getZonaById(datos[1].id) || 'comunas'}}</span></h2>
        </div>
          <div class="section__box-select">
            <multiselect
            v-model="selectedComunas[1]"
            track-by="value"
            label="text"
            placeholder="Seleccione una comuna"
            :options="comunas"
            @input="changeComunasDer"
            selectLabel="Presione enter para seleccionar"
            deselectLabel="Presiones enter para remover"
            selectedLabel="Seleccionado"
            >
            <template slot="noResult">Sin resultados</template>
            <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.text }}</strong></template>
          </multiselect>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="chart-selection">
        <div class="row">
          <div class="col-12 col-md-6 d-flex align-items-center">
            <div v-for="radioButton in radioButtons" :key="radioButton.value" class="custom-control custom-radio custom-control-inline">
              <input type="radio" class="custom-control-input" :id="radioButton.id" name="comunas" @change="updateChart" v-model="selectedTipo" :value="radioButton.value" :checked="radioButton.checked">
              <label class="custom-control-label" :for="radioButton.id">{{radioButton.name}}</label>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <date-picker v-model="range" @change="changeRange" valueType="format" range :disabledDate="disableDates" :clearable="false"/>
          </div>
        </div>
      </div>
      <div class="chart-line">
        <canvas ref="chart"></canvas>
      </div>
      <div class="chart-legend">
        <ul class="legend">
          <li><b>{{ getZonaById(datos[0].id) }}:</b></li>
          <li class="legend__item legend__item--solid">Contagios</li>
        </ul>
        <ul class="legend">
          <li><b>{{ getZonaById(datos[1].id) || 'Comunas' }}:</b></li>
          <li class="legend__item legend__item--solid">Contagios</li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <grm-tasa label="Tasas comunas" :datos="this.datos[0]"/>
      </div>
      <div class="col-12 col-md-6">
        <grm-tasa label="Tasas comunas" :datos="this.datos[1]"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/es';
import { chartDefaults, processData, disableDates } from '../../charts'
import { getComunas, getComunasData } from '../../api'
import { getRegionByDiario } from '../../api/regionbydiario'
import GrmTasa from '../commons/GrmTasa'
export default {
  data() {
    return {
      chart: null,
      idDiario: null,
      regiones: [],
      selectedComunas:[],
      selectedTipo: 'contagios',
      comunas: [],
      range: [],
      datos: [
        { id: null, data: [], selected: 'contagios' }, // Comunas Izq
        { id: null, data: [], selected: 'contagios' } // Comunas Der
      ],
      radioButtons:[
        { id:'contagiosButtonComunas',  value:'contagios', name:'Contagios', checked: true },
      ]
    }
  },

  methods: {
    async updateChart() {
      // ¿no hay grafico? no hacemos nada
      if (!this.chart) return false

      this.chart.data.datasets = []
      this.datos.forEach((dato, index) => {
        let datos = processData(this.selectedTipo, dato.data, index)
        this.chart.data.datasets.push({
          label: `${this.getZonaById(this.datos[index].id)} - ${this.selectedTipo}`,
          data: datos.data,
          borderDash: datos.borderDash,
          borderColor: datos.borderColor(),
          pointBorderColor: datos.borderColor(),
          pointStyle: datos.pointStyle,
          pointHoverBorderColor: datos.borderColor(),
          pointBackgroundColor: datos.borderColor(),
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderWidth: 4,
          pointHoverRadius: 6,
          pointHitRadius: 10,
          spanGaps: true
        })

        if (index === 0) {
          this.chart.data.labels = datos.labels
        }
      })

      this.chart.update()
    },

    async createChart() {
      const datos = processData('contagios', this.datos[0].data)

      this.chart = new this.$chart(this.$refs.chart, {
        type: 'line',
        data: {
          labels: datos.labels,
          datasets:[{
            label: `${this.getZonaById(this.datos[0].id)} - contagios`,
            data: datos.data,
            borderColor: datos.borderColor,
            pointBorderColor: datos.borderColor,
            pointHoverBorderColor: datos.borderColor,
            pointBackgroundColor: datos.borderColor,
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderWidth: 4,
            pointHoverRadius: 6,
            pointHitRadius: 10,
            labelColors: '#000'
          }],
        },
        options: chartDefaults.lineChart
      })
    },

    async changeComunasIzq() {
     if (!this.selectedComunas[0]) return false
      const datos = await getComunasData(this.selectedComunas[0].value, this.range)

      // Seteamos los datos de la región solicitada
      this.$set(this.datos[0], 'id', this.selectedComunas[0].value)
      this.$set(this.datos[0], 'data', datos.data)
      this.$set(this.datos[0], 'habitantes', datos.habitantes)
      this.$set(this.datos[0], 'ultimaActualizacion', datos.ultimaActualizacion)

      // actualizamos el gráfico
      this.updateChart()
    },

    async changeComunasDer() {
      if (!this.selectedComunas[1]) return false

      const datos = await getComunasData(this.selectedComunas[1].value, this.range)

      // Seteamos los datos de la comuna solicitada
      this.$set(this.datos[1], 'id', this.selectedComunas[1].value)
      this.$set(this.datos[1], 'data', datos.data)
      this.$set(this.datos[1], 'habitantes', datos.habitantes)
      this.$set(this.datos[1], 'ultimaActualizacion', datos.ultimaActualizacion)

      this.updateChart()
    },

    async changeRange() {
      const datosIzq = await getComunasData(this.datos[0].id, this.range)
      const datosDer = await getComunasData(this.datos[1].id, this.range)

      // Este es el dato de la izquierda
      this.$set(this.datos[0], 'data', datosIzq.data)
      this.$set(this.datos[0], 'habitantes', datosIzq.habitantes)
      this.$set(this.datos[0], 'ultimaActualizacion', datosIzq.ultimaActualizacion)

      // Este es el dato de la derecha
      this.$set(this.datos[1], 'data', datosDer.data)
      this.$set(this.datos[1], 'habitantes', datosDer.habitantes)
      this.$set(this.datos[1], 'ultimaActualizacion', datosDer.ultimaActualizacion)

      this.updateChart()
    },

    getZonaById(id) {
      let zona
      if (!id) return false

      for (let i = 0; i < this.regiones.length; i++) {
        if (this.regiones[i].value === id) {
          zona = this.regiones[i].text
        }
      }

      if (!zona) {
        for (let i = 0; i < this.comunas.length; i++) {
          if (this.comunas[i].value === id) {
            zona = this.comunas[i].text
          }
        }
      }

      return zona
    },

    disableDates: disableDates
  },

  components: { DatePicker, GrmTasa },

  async mounted() {
    let id = window.app.idDiario
    this.datos[0].id = getRegionByDiario(id)
    this.comunas = await getComunas(this.datos[0].id)
    const datos = await getComunasData(this.datos[0].id, this.range)

    // Seteamos los datos de la comuna solicitada
    this.$set(this.datos[0], 'data', datos.data)
    this.$set(this.datos[0], 'habitantes', datos.habitantes)
    this.$set(this.datos[0], 'ultimaActualizacion', datos.ultimaActualizacion)

    this.datos[0].id = this.comunas[0].value
    this.comunas = await getComunas()

    this.selectedComunas[0] = this.comunas.find(comuna => comuna.value === this.datos[0].id)

    this.createChart()
  },

  created() {
    let date = new Date();
    date.setDate(date.getDate() - 30);
    this.range = [date.toISOString().slice(0,10), new Date().toISOString().slice(0,10)]
  }
}
</script>
